import type { FC, ReactNode } from "react";
import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
} from "@mui/material";
import CloseRounded from "@mui/icons-material/CloseRounded";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { useDeviceBreakpoint } from "@/admin/shared/hooks";
import { Logo, StyledDrawer } from "@/admin/shared/ui";

export interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  userCard?: ReactNode;
  menu?: ReactNode;
  onSignOut: () => void;
  signOutLoading: boolean;
}

export const Sidebar: FC<SidebarProps> = ({
  isOpen,
  onClose,
  userCard,
  menu,
  onSignOut,
  signOutLoading,
}) => {
  const isLg = useDeviceBreakpoint("lg");

  return (
    <StyledDrawer
      anchor="left"
      open={isOpen || !isLg}
      onClose={onClose}
      variant={isLg ? "temporary" : "persistent"}
    >
      {/* Шапка не сжимается — иначе длинное меню съедало бы карточку
          пользователя, а Card обрезает всё, что не поместилось */}
      <Box sx={{ flexShrink: 0 }}>
        <Stack
          direction="row"
          gap={{ sm: 3, xs: 1 }}
          sx={{
            ml: { lg: 0, xs: 3 },
            mt: { lg: 3, sm: 1.5, xs: 1 },
            justifyContent: { lg: "center" },
          }}
        >
          <IconButton
            size="medium"
            edge="start"
            sx={{
              color: "text.secondary",
              display: { xs: "flex", lg: "none" },
            }}
            onClick={onClose}
          >
            <CloseRounded />
          </IconButton>
          <Logo />
        </Stack>

        <Divider />

        {userCard}

        <Divider />
      </Box>

      {/* Меню забирает всю оставшуюся высоту и скроллится самостоятельно */}
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>{menu}</Box>

      <Divider />

      <List disablePadding sx={{ flexShrink: 0 }}>
        <ListItem disablePadding>
          <ListItemButton disabled={signOutLoading} onClick={onSignOut}>
            <ListItemIcon>
              <PowerSettingsNewIcon />
            </ListItemIcon>
            <ListItemText primary="Выйти" />
          </ListItemButton>
        </ListItem>
      </List>
    </StyledDrawer>
  );
};
